<template>
  <ModalDialog
    ref="dialog"
    title="Scan Warnings"
    icon="fa-exclamation-triangle"
    submitTitle="Override"
    :submitDisabled="!hasValidName"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="3">
      <FormRow label="Scan Warnings">
        <FormStaticLabel>
          <ul v-html="convertNewlinesToListItems(overrideWarningOptions.message)"></ul>
        </FormStaticLabel>
      </FormRow>

      <FormRow label="Override">
        <FormInputText v-model="overrideName" placeholder="Enter user name to override" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'

import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'StationScanWarningDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
    productionStageId: Number,
    productionStationId: Number,
    overrideWarningOptions: Object
  },
  data() {
    return {
      form: {},
      overrideName: ''
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    hasValidName() {
      return ('' + this.overrideName).trim().length > 0
    }    
  },
  methods: {
    show() {
      this.form = {}

      return modalDialog.methods.show.call(this, arguments)
    },
    onSubmitted() {
    },
    onClosed() {
      this.modalClosed(null)
    },
    onSubmitted() {
      this.modalClosed({ name: this.overrideName })
      this.hide()
    }
  }
}
</script>